Object.defineProperties(HTMLFormElement.prototype, {})
Object.defineProperties(HTMLInputElement.prototype, {
    nodeList: {
        get() { return this.form.elements.namedItem(this.name) }
    }
})